@if (!currentState) {
<span>Cargando...</span>
} @else {
<app-logo-header></app-logo-header>
<!-- Form Container -->
<div class="w-full">
  <!-- Page Title -->
  <div class="my-4">
    <ng-container *ngTemplateOutlet="estamosAUnPaso"></ng-container>
  </div>

  <!-- Access Method Options -->
  <section class="space-y-2 mb-6">
    <ng-container *ngTemplateOutlet="smsOption"></ng-container>
    <ng-container *ngTemplateOutlet="emailOption"></ng-container>
    <ng-container *ngTemplateOutlet="passwordOption"></ng-container>
  </section>

  <!-- Dynamic Content Based on Selection -->
  <main class="mt-6">
    @if (selectedMethod() === null) {
    <ng-container *ngTemplateOutlet="passwordLogin"></ng-container>
    } @else { @if(!otpSent()) { @if(selectedMethod() ===
    TipoVerificacionEnum.LOGIN_CON_TELEFONO && (!currentState.loginFlow.telefono
    || !currentState.loginFlow.prefijoTelefono)){
    <div class="p-2.5 bg-red-50 border border-red-200 rounded-lg" role="alert">
      <p class="text-red-600 text-xs">
        Debes tener un número de teléfono asociado a tu cuenta para enviar un
        código de verificación por SMS.
      </p>
    </div>
    } @else {
    <ng-container *ngTemplateOutlet="sendOtpButton"></ng-container>
    } } @else {
    <ng-container *ngTemplateOutlet="otpVerification"></ng-container>
    } }
  </main>
</div>
<!-- Templates -->
<ng-template #estamosAUnPaso>
  <header class="mb-6 xl:mb-0">
    <h1 class="text-lg md:text-xl font-bold text-gray-900 mb-1 fs-condensed">
      ¡Estamos a un paso! Elegí un método de acceso
    </h1>
    <p class="text-gray-600 text-sm">
      Para
      <span class="font-semibold text-allasRed">{{
        currentState.loginFlow.email
      }}</span>
    </p>
  </header>
</ng-template>

<ng-template #smsOption>
  <button
    class="w-full p-3 rounded-lg text-left transition-colors border focus:outline-none focus:ring-2 focus:ring-offset-2"
    [ngClass]="{
      'border-blue-200 bg-blue-50 hover:bg-blue-100 focus:ring-blue-500': selectedMethod() === TipoVerificacionEnum.LOGIN_CON_TELEFONO,
      'border-gray-300 hover:bg-gray-50 focus:ring-gray-500': selectedMethod() !== TipoVerificacionEnum.LOGIN_CON_TELEFONO,
    }"
    (click)="selectMethod(TipoVerificacionEnum.LOGIN_CON_TELEFONO)"
    aria-label="Seleccionar envío de OTP por SMS"
  >
    <div class="font-semibold text-gray-900 text-sm mb-1">
      ENVIAR CÓDIGO DE VERIFICACIÓN POR SMS
    </div>
    <div class="text-xs text-gray-600">
      al número @if (currentState.loginFlow.prefijoTelefono &&
      currentState.loginFlow.telefono) {
      {{ currentState.loginFlow.prefijoTelefono }}
      {{ currentState.loginFlow.telefono }}
      } @else { SIN TELEFONO ASOCIADO }
    </div>
  </button>
</ng-template>

<ng-template #emailOption>
  <button
    class="w-full p-3 rounded-lg text-left transition-colors border focus:outline-none focus:ring-2 focus:ring-offset-2"
    [ngClass]="{
      'border-blue-200 bg-blue-50 hover:bg-blue-100 focus:ring-blue-500': selectedMethod() === TipoVerificacionEnum.LOGIN_CON_EMAIL,
      'border-gray-300 hover:bg-gray-50 focus:ring-gray-500': selectedMethod() !== TipoVerificacionEnum.LOGIN_CON_EMAIL,
    }"
    (click)="selectMethod(TipoVerificacionEnum.LOGIN_CON_EMAIL)"
    aria-label="Seleccionar envío de OTP por correo electrónico"
  >
    <div class="font-semibold text-gray-900 text-sm mb-1">
      ENVIAR CÓDIGO DE VERIFICACIÓN POR CORREO
    </div>
    <div class="text-xs text-gray-600">
      a {{ currentState.loginFlow.email }}
    </div>
  </button>
</ng-template>

<ng-template #passwordOption>
  <button
    class="w-full p-3 rounded-lg text-left transition-colors border focus:outline-none focus:ring-2 focus:ring-offset-2"
    [ngClass]="{
        'border-blue-200 bg-blue-50 hover:bg-blue-100 focus:ring-blue-500': selectedMethod() === null,
        'border-gray-300 hover:bg-gray-50 focus:ring-gray-500': selectedMethod() !== null,
      }"
    (click)="selectMethod(null)"
    aria-label="Seleccionar ingreso con contraseña"
  >
    <div class="font-semibold text-gray-900 text-sm mb-1">
      Ingresar Contraseña
    </div>
    <div class="text-xs text-gray-600">
      usa tu contraseña para iniciar sesión
    </div>
  </button>
</ng-template>

<ng-template #sendOtpButton>
  <button
    class="w-full bg-allasRed text-white py-2.5 rounded-lg font-medium text-base hover:bg-allasRed-500 transition-colors focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:ring-offset-2"
    [ngClass]="{
      'bg-gray-300 text-gray-500 cursor-not-allowed': isOtpSending(),
    }"
    [disabled]="isOtpSending()"
    (click)="sendOtp()"
    aria-label="Enviar código de verificación"
  >
    @if (isOtpSending()) {
    <span class="flex items-center justify-center">
      <app-loading-spinner size="sm"></app-loading-spinner>
      Enviando código de verificación...
    </span>
    } @else { ENVIAR CÓDIGO DE VERIFICACIÓN }
  </button>
</ng-template>

<ng-template #otpVerification>
  <app-otp-block
    [length]="4"
    [instructionText]="
      selectedMethod() === TipoVerificacionEnum.LOGIN_CON_TELEFONO
        ? 'Hemos enviado un código de 4 dígitos al número que tienes registrado. Escríbelo a continuación para continuar con tu perfil.'
        : 'Hemos enviado un código de 4 dígitos al correo que tienes registrado. Escríbelo a continuación para continuar con tu perfil.'
    "
    [isLoading]="isLoading()"
    [submitLabel]="
      selectedMethod() === TipoVerificacionEnum.LOGIN_CON_TELEFONO
        ? 'VERIFICAR CÓDIGO'
        : 'VERIFICAR CÓDIGO'
    "
    (onSubmit)="verifyOtp($event)"
    [resendTimer]="countdown()"
  ></app-otp-block>
</ng-template>

<ng-template #passwordLogin>
  <section class="space-y-4">
    <div>
      <label
        for="password"
        class="block text-sm font-medium text-gray-700 mb-1"
      >
        Contraseña
      </label>
      <div class="relative">
        <input
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          [(ngModel)]="password"
          placeholder="Ingresa tu contraseña"
          class="w-full px-3 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:border-transparent text-gray-700 text-sm"
          (keyup.enter)="login()"
          aria-describedby="password-help"
        />
        <button
          title="Mostrar contraseña"
          type="button"
          class="absolute inset-y-0 right-0 pr-3 flex items-center"
          (click)="togglePasswordVisibility()"
          [attr.aria-label]="
            showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
          "
          [title]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
        >
          <svg
            class="w-4 h-4 text-gray-400 hover:text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            @if (showPassword) {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L8.464 8.464m1.414 1.414L8.464 8.464m1.414 1.414l8.486 8.486"
            ></path>
            } @else {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            ></path>
            }
          </svg>
        </button>
      </div>
    </div>

    <div class="flex items-center gap-2">
      <input
        type="checkbox"
        id="rememberPassword"
        [(ngModel)]="rememberPassword"
        class="w-4 h-4 text-appPrimary-600 bg-gray-100 border-gray-300 rounded focus:ring-appPrimary-500 focus:ring-2"
      />
      <label for="rememberPassword" class="text-xs text-gray-600">
        Recordar contraseña
      </label>
    </div>

    @if (loginError()) {
    <div class="p-2.5 bg-red-50 border border-red-200 rounded-lg" role="alert">
      <p class="text-red-600 text-xs">{{ loginError() }}</p>
    </div>
    }

    <button
      class="w-full bg-allasRed text-white py-2.5 rounded-lg font-medium text-base hover:bg-allasRed-500 transition-colors focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:ring-offset-2 flex items-center justify-center"
      [disabled]="!password || isLoading()"
      [class.opacity-50]="!password || isLoading()"
      [class.cursor-not-allowed]="!password || isLoading()"
      (click)="login()"
      aria-label="Iniciar sesión con contraseña"
    >
      @if (isLoading()) {
      <span class="flex items-center justify-center">
        <app-loading-spinner size="sm"></app-loading-spinner>
        Iniciando sesión...
      </span>
      } @else {
      <span>Iniciar Sesión</span>
      }
    </button>
  </section>
</ng-template>

}
